export const EXPORT_LIMIT = 10000;
export const RETRIEVE_LIMIT = 2500;
